import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { DiscountListType } from "@/features/cart/types/discount.type";
import { getDiscountsList } from "@/features/discounts/api/get-discounts-list";

type UseGetDiscountListParams = {
  params?: RequestInit;
  options?: Omit<
    UseQueryOptions<DiscountListType, unknown, DiscountListType, string[]>,
    "queryFn" | "queryKey"
  >;
};

export const useGetDiscountList = ({
  params,
  options,
}: UseGetDiscountListParams) => {
  return useQuery({
    queryKey: ["discounts-list"],
    queryFn: () => getDiscountsList({ params, client: true }),
    ...options,
  });
};
